import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appDynamicPaymentOption]',
    standalone: false
})
export class DynamicPaymentOptionDirective {

  constructor(public viewContainerRef: ViewContainerRef) {}

}
